import * as moment from 'jalali-moment';
export const gregorianToJalaliWithTime = (unix_timestamp) => {
    var date = new Date(Number(unix_timestamp));
    const m = moment(date);
    let jalali = m.locale('fa').format("DD MMMM YYYY") + ' ساعت ' + m.locale('fa').format('HH:mm');
    return jalali;
}
export const gregorianToJalaliUnix = (unix_timestamp) => {
    var date = new Date(Number(unix_timestamp));
    const m = moment(date);
    let jalali = m.locale('fa').format("DD MMMM YYYY");
    return jalali;
}
export const gregorianToJalali = (date) => {
    const m = moment(date);
    let jalali = m.locale('fa').format("DD MMMM YYYY");
    return jalali;
}